import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import './index.css';

const container = document.getElementById('root');
// React-snap captures browser DOM, not React server markup. Mounting normally
// avoids invalid React 18 hydration of merged text nodes in those snapshots.
// The prerendered document stays available to crawlers and before JS loads.
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
